import { __assign } from "tslib";
import React, { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
var InputAddon = forwardRef(function (props, ref) { return React.createElement("div", __assign({}, props, { ref: ref })); });
var InputLeftAddon = forwardRef(function (props, ref) { return (React.createElement(InputAddon, __assign({}, props, { className: twMerge('bg-alto h-12 flex items-center py-0 px-2 rounded-l-default', props.className), ref: ref }))); });
var InputRightAddon = forwardRef(function (props, ref) { return (React.createElement(InputAddon, __assign({}, props, { className: twMerge('bg-alto h-12 flex items-center py-0 px-2 rounded-r-default', props.className), ref: ref }))); });
InputLeftAddon.displayName = 'InputLeftAddon';
InputRightAddon.displayName = 'InputRightAddon';
export { InputLeftAddon, InputRightAddon };
